import {
  configureApiClient,
  createDefaultStorage,
  SessionStore,
} from "@brad-tipper/app-frontend";

import { API_URL } from "~/lib/constants";
import { client } from "./generated/client.gen";

/** Holds the signed-in tokens and refreshes them (single-flight). */
export const sessionStore = new SessionStore({
  baseUrl: API_URL,
  storage: createDefaultStorage(),
  key: "gearsync.session",
});

configureApiClient({ client, baseUrl: API_URL, session: sessionStore });

export { client };
export * as api from "./generated/sdk.gen";
